import { render } from "./Preguntas.vue?vue&type=template&id=6cc320b4"
import script from "./Preguntas.vue?vue&type=script&lang=js"
export * from "./Preguntas.vue?vue&type=script&lang=js"

import "./Preguntas.vue?vue&type=style&index=0&id=6cc320b4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__